import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    switchesContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    contentContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    maxContentContainer: {
        justifyContent: "center",
        alignItems: "center",
        maxWidth: 850,
        width: "100%"
    },
    centeredText: {
        textAlign: "center"
    },
    centeredText2: {
        textAlign: "center"
    },
    centeredText3: {
        textAlign: "center"
    },
    descText: {
        marginBottom: 20
    },
    logoImage: {
        height: 300,
        width: 300
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
